import type { ReactNode } from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { ModalHeader } from "../../../common/modal/ModalHeader";

interface IHeaderProps {
    domain: string;
    platform: ReactNode;
    favicon: string;
    postCounter: string;
    onClose: () => void;
}

export const Header = ({ domain, favicon, platform, postCounter, onClose }: IHeaderProps) => {
    const { translate } = useTranslate();

    return (
        <ModalHeader
            domain={domain}
            favicon={favicon}
            onClose={onClose}
        >
            <ModalHeader.InfoGroup
                title={translate("activation.alerts.cards.social-post.modal.header.social-platform")}
            >
                {platform}
            </ModalHeader.InfoGroup>

            <ModalHeader.InfoGroup title={translate("activation.alerts.cards.social-post.modal.header.new-posts")}>
                {postCounter}
            </ModalHeader.InfoGroup>
        </ModalHeader>
    );
};
